import React from 'react';
import { SlideContent } from '../components/canvas/SlideContent';
import { SlideFooter } from '../components/canvas/SlideFooter';
import { SlideLogo } from '../components/canvas/SlideLogo';
import { NudgeableGroup } from '../components/canvas/NudgeableGroup';

/**
 * Gradient Card layout — tech/liquid glass style.
 * Floating centered card with gradient-glow border.
 * Footer pinned at bottom for cross-template consistency.
 */
export function GradientCardLayout({ data, fontPreset, logoEnabled = true, logoUrl = null, logoSize = null, logoIsDark = false, pc }) {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <NudgeableGroup groupId="content" className="relative w-[85%] max-w-[900px]">
        {/* Gradient glow border */}
        <div
          className="absolute -inset-[2px] rounded-[32px] opacity-60"
          style={{
            background: `linear-gradient(135deg, ${pc.accent(0.4)}, ${pc.accentSoft(0.3)})`,
          }}
        />
        {/* Inner card */}
        <div
          className="relative rounded-[30px] p-[56px]"
          style={{ backgroundColor: pc.surfaceAt(0.45) }}
        >
          {/* Logo */}
          {logoEnabled && (
            <div className="mb-6">
              <SlideLogo className="h-14 w-14" style={{ color: pc.text(0.60) }} logoUrl={logoUrl} size={logoSize} isDark={logoIsDark} />
            </div>
          )}

          <SlideContent
            data={data}
            fontPreset={fontPreset}
            pc={pc}
            options={{
              showFooter: false,
              mutedOpacity: 0.70,
              subtleOpacity: 0.50,
            }}
          />
        </div>
      </NudgeableGroup>

      {/* Footer — pinned at bottom */}
      <div className="absolute bottom-[64px] left-[64px] right-[64px]">
        <SlideFooter data={data} pc={pc} />
      </div>
    </div>
  );
}
